module.exports = __webpack_public_path__ + "static/img/hlx_gzh.ce1f837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlx_gzh.png
// module id = UWIi
// module chunks = 169